// ABOUTME: Downloads a file from a url to the user's disk under its original file name.
// ABOUTME: Fetches to a blob and clicks a synthetic anchor; falls back to a new tab if the fetch fails.

export const downloadFile = async (url, fileName) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Download failed with status ${response.status}`);
        }
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileName || "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
    } catch (error) {
        // Cross-origin anchors ignore the download attribute, so a plain new
        // tab is the best remaining option when the blob route is unavailable.
        window.open(url, "_blank", "noopener,noreferrer");
    }
};
